
import { Line } from "vue-chartjs";

/**
 * Grafik tren capaian kepatuhan visite DPJP per bulan (%) + garis target.
 * Pola sama dengan PpiBundleRekapChart (chart.js 2 / vue-chartjs).
 */
export default {
  extends: Line,
  props: {
    labels: { type: Array, default: () => [] },
    data: { type: Array, default: () => [] },
    seriesLabel: { type: String, default: "Capaian (%)" },
    target: { type: Number, default: 80 }
  },
  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: this.seriesLabel,
            data: this.data,
            borderColor: "#1976D2",
            backgroundColor: "#1976D2",
            pointRadius: 4,
            borderWidth: 2,
            fill: false,
            spanGaps: true,
            lineTension: 0
          },
          {
            label: `Target ${this.target}%`,
            data: this.labels.map(() => this.target),
            borderColor: "#E53935",
            borderDash: [6, 4],
            pointRadius: 0,
            borderWidth: 1.5,
            fill: false,
            lineTension: 0
          }
        ]
      };
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              display: true,
              ticks: {
                min: 0,
                max: 100,
                stepSize: 20,
                callback: (value: number) => value + "%"
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            label: (item: any, data: any) => {
              const label = data.datasets[item.datasetIndex].label || "";
              return `${label}: ${item.yLabel === null ? "-" : item.yLabel + "%"}`;
            }
          }
        }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.renderChart(this.chartData, this.options);
      }
    }
  }
};
